module.exports = __webpack_public_path__ + "img/sushi-king-menu-04.a725b074.png";